<template>
  <div>
    <div class="container">
      <div style="margin-bottom: 20px;">{{ title }}</div>
      <el-form
        :rules="rules"
        :inline="true"
        :model="workflowCompany"
        ref="workflowCompany"
        label-width="120px"
        label-position="right"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批流程名称：" prop="auditName">
              <el-input
                v-model.trim="workflowCompany.auditName"
                maxlength="20"
                placeholder="请输入审批流程名称"
                style="width: 500px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
              <el-form-item label="审批流程节点：" prop="workflowNode" v-if="type == 3">
                  <el-select
                  v-model.trim="workflowCompany.workflowNode"
                  maxlength="20"
                  placeholder="请输入审批流程名称"
                  style="width: 500px;"
                  >
                  <el-option :value="0" label="发起询价">发起询价</el-option>
                  <el-option :value="1" label="选商定价">选商定价</el-option>
                </el-select>
              </el-form-item>
          </el-col>
      </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批流程说明：" prop="remake">
              <el-input
                v-model.trim="workflowCompany.remake"
                maxlength="300"
                show-word-limit
                placeholder="请输入审批流程说明"
                type="textarea"
                style="width: 500px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="tips">
        <span
          style="
              font-size: 12px;
              float: 20px;
              margin: 0 0 20px 5px;
              display: inline-block;
            "
        >
          说明：审批流程设置支持自定义审批层级节点，在每个节点中，可以设置多个审批人，其中的任何一人审批通过后即可进入下一层级审批节点。
        </span>
      </div>
      <!--表单添加-->
      <el-button type="success" @click="AddListRow('workflowCompany')">添加审批节点</el-button>
      <TableList
        style="margin-top: 15px"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <!-- <template v-slot:idx="idx">
            第{{ idx.scope.$index + 1 }}审批节点
          </template> -->
        <template v-slot:approver="approver">
          <el-col :span="18">
            <div style="display: flex;">
              <el-tooltip
                class="item"
                effect="light"
                :disabled="disabledFlag(approver.scope.row.approverListStr)"
                :content="approver.scope.row.approverListStr"
                placement="top"
              >
                <el-input v-model="approver.scope.row.approverListStr" :disabled="true" />
              </el-tooltip>
              <el-button
                size="mini"
                type="primary"
                plain
                icon="el-icon-search"
                :disabled="false"
                @click="editApprover(approver.scope.row, approver.scope.$index)"
              />
            </div>
          </el-col>
        </template>
        <!-- 操作 -->
        <template v-slot:operation="tData">
          <el-button size="mini" type="danger" @click="handleDelete(tData.scope.$index)">
            删除审批节点
          </el-button>
        </template>
      </TableList>
      <div
        style="margin-top: 20px; text-align: center;display: flex;justify-content: space-between;"
      >
        <el-button @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleAddPurchase()">
          {{ $route.query.operateType == 'edit' ? '确定修改' : '确定添加' }}
        </el-button>
      </div>
    </div>
    <AddSupplierDialog
      :addSupplierVisible.sync="addSupplierVisible"
      @getSelectCompany="getSelectCompany"
      :companyTableList="companyTableList"
      v-if="addSupplierVisible"
    ></AddSupplierDialog>
  </div>
</template>

<script>
import { isSpace } from '../../../utils/validate';
import TableList from '@/modules/projectA/components/common/e-table-list';
import Api from '../../../api/approve/index';
import AddSupplierDialog from './addSupplierDialog';
export default {
  name: 'createApprove',
  components: {
    TableList,
    AddSupplierDialog,
  },
  data() {
    const validateSpace = (rule, value, callback) => {
      if (isSpace(value)) {
        return callback(new Error('请输入非空格字符！'));
      } else if (!value) {
        return callback(new Error('请输入必填项！'));
      } else {
        return callback();
      }
    };
    return {
      input: '',
      workflowCompany: {
        auditName: '',
        auditType: '',
        addAuditNodeAOList: '',
        remake: '',
      },
      repetitionFlag: false,
      rules: {
        auditName: [
          {
            pattern: /^[\w\u4e00-\u9fa5]+$/,
            message: '输入框类型：汉字，英文，数字，英文下划线。',
            trigger: 'blur',
          },
          { required: true, trigger: 'blur', validator: validateSpace },
        ],
      },
      tableData: [],
      tableLabel: [
        {
          label: '审批节点',
          param: 'auditNodeName',
          align: 'center',
        },
        {
          label: '审批人',
          param: 'aftersalesNo',
          align: 'center',
          slot: 'approver',
        },
        {
          label: '操作',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      approverEdit_flag: false,
      addSupplierVisible: false,
      companyTableList: [],
      tableInx: '',
      type: '',
      typeList: ['', '', '', '需求计划审批流程', '采购计划审批流程', '询比价审批流程'],
      title: '',
      auditName: '',
    };
  },

  watch: {
    // 利用watch方法检测路由变化：
    $route: function(val) {
      this.workflowCompany.auditType = val.query.type;
      this.title = this.typeList[this.workflowCompany.auditType];
      if (val.query.operateType) {
        this.getAuditFlowDetail();
      } else {
        this.workflowCompany.auditName = '';
        this.workflowCompany.remake = '';
        this.$set(this, 'tableData', []);
      }
    },
  },
  created() {
    this.workflowCompany.auditType = this.$route.query.type;
    this.title = this.typeList[this.workflowCompany.auditType];
    if (this.$route.query.operateType) {
      this.getAuditFlowDetail();
    }
  },
  destroyed() {},
  methods: {
    //点击加号添加一行数据
    AddListRow(workflowCompany) {
      this.$refs[workflowCompany].validate(valid => {
        if (valid) {
          this.tableData.push({});
          this.$set(
            this.tableData[this.tableData.length - 1],
            'auditNodeName',
            '第' + this.tableData.length + '个审批点'
          );
        } else {
          console.log('请输入审批流程名称');
          return false;
        }
      });
    },

    disabledFlag(val) {
      if (val) {
        return false;
      } else {
        return true;
      }
    },

    handleDelete(index) {
      this.$confirm('该审批流程将被删除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          try {
            // 弄明白 confirmWorkFlowSkusList 这是数组是干啥的
            this.tableData.splice(index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.tableData.forEach((item, index) => {
              this.$set(item, 'auditNodeName', '第' + (index + 1) + '审批节点');
            });
            return;
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    editApprover(row, index) {
      if (this.$route.params.operateType == 'edit') {
        this.companyTableList = row.auditNodeMemberVOList;
      } else {
        this.companyTableList = row.approverList;
      }

      this.tableInx = index;
      this.addSupplierVisible = true;
    },
    handleAddPurchase() {
      this.tableData.map(item => {
        if (item.auditName == this.workflowCompany.auditName) {
          this.repetitionFlag = true;
        }
      });
      if (this.repetitionFlag) {
        this.repetitionFlag = false;
        return this.$message.error('已存在同名称审批流程，请重新命名!');
      }
      if (this.tableData.length < 1) {
        this.$message({
          type: 'error',
          message: '请先添加审批节点！',
        });
        return;
      }
      this.tableData.map(item => {
        if (item.approverList == '') {
          this.$message({
            type: 'info',
            message: '某审批节点为空',
          });
          return;
        }
      });

      let params = {
        auditName: '',
        addAuditNodeAOList: [],
        auditType: this.type,
        remake: '',
      };
      params.auditName = this.workflowCompany.auditName;

      params.auditType = this.$route.query.type;

      params.remake = this.workflowCompany.remake;

      if (this.$route.query.operateType != 'edit') {
        this.tableData.forEach(param => {
          this.$set(param, 'addAuditNodeMemberAOList', param.approverList);

          this.$set(param, 'auditNodeName', param.auditNodeName);

          param.addAuditNodeMemberAOList.forEach(skuParam => {
            this.$set(skuParam, 'nodeMemberPhone', skuParam.mobile);
            this.$set(skuParam, 'nodeMemberId', skuParam.memberId);
            this.$set(skuParam, 'nodeMemberName', skuParam.realName);
            this.$set(skuParam, 'nodeMemberMail', skuParam.email);
            this.$delete(skuParam, 'mobile');
            this.$delete(skuParam, 'memberId');
            this.$delete(skuParam, 'realName');
            this.$delete(skuParam, 'email');
          });
          this.$delete(param, 'approverList');
          this.$delete(param, 'approverListStr');
        });
      } else {
        this.tableData.forEach(param => {
          this.$set(param, 'auditNodeName', param.auditNodeName);
          if (param.approverList) {
            if (param.addAuditNodeMemberAOList) {
              this.$delete(param, 'addAuditNodeMemberAOList');
            }
            this.$set(param, 'addAuditNodeMemberAOList', param.approverList);

            param.addAuditNodeMemberAOList.forEach(skuParam => {
              this.$set(skuParam, 'nodeMemberPhone', skuParam.mobile);
              this.$set(skuParam, 'nodeMemberId', skuParam.memberId);
              this.$set(skuParam, 'nodeMemberName', skuParam.realName);
              this.$set(skuParam, 'nodeMemberMail', skuParam.email);
              this.$delete(skuParam, 'mobile');
              this.$delete(skuParam, 'memberId');
              this.$delete(skuParam, 'realName');
              this.$delete(skuParam, 'email');
            });
            this.$delete(param, 'approverList');
            this.$delete(param, 'approverListStr');
          }
        });
      }

      this.$set(params, 'addAuditNodeAOList', this.tableData);

      if (this.$route.query.operateType == 'edit') {
        this.$set(params, 'auditId', this.$route.query.auditId);
        if (this.auditName == this.workflowCompany.auditName) {
          this.$delete(params, 'auditName');
        }
        Api.editApprove(params).then(res => {
          if (res.code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            this.tableData.length = 0;
            this.handleBack();
          } else {
            // this.$message({
            //   type: "info",
            //   message: res.message,
            // });
          }
        });
      } else {
        Api.addApprove(params).then(res => {
          if (res.code == '200') {
            this.$message({
              type: 'success',
              message: '添加成功!',
            });
            this.tableData.length = 0;
            this.handleBack();
          } else {
            // this.$message({
            //   type: "info",
            //   message: res.message,
            // });
          }
        });
      }
    },
    goToUrl() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
    removeStore() {
      this.workflowCompany.auditName = '';
      this.workflowCompany.auditType = '';
      this.workflowCompany.addAuditNodeAOList = [];
      this.workflowCompany.description = '';
    },
    handleBack() {
      this.removeStore();
      this.goToUrl();
    },
    getSelectCompany(val) {
      this.$set(this.tableData[this.tableInx], 'approverList', [...val]);
      this.$set(
        this.tableData[this.tableInx],
        'auditNodeName',
        '第' + (this.tableInx + 1) + '审批节点'
      );

      this.companyTableList = [...val];

      let tmpArr = '';
      this.tableData[this.tableInx].approverList.forEach(item => {
        tmpArr += item.realName + ',';
      });

      tmpArr = tmpArr.substring(0, tmpArr.length - 1);
      this.$set(this.tableData[this.tableInx], 'approverListStr', tmpArr);
    },
    //当时编辑的时候调用详情接口
    async getAuditFlowDetail() {
      let params = {
        auditId: this.$route.query.auditId,
      };

      let res = await Api.queryApproveDetail(params);
      if (res.code == '200') {
        this.tableData = res.data.auditNodeVOList;
        this.workflowCompany.auditName = res.data.auditName;
        this.workflowCompany.remake = res.data.remake;
        this.auditName = this.workflowCompany.auditName;

        this.tableData.forEach(item => {
          this.$set(item, 'addAuditNodeMemberAOList', item.auditNodeMemberVOList);
          this.$delete(item, 'auditNodeMemberVOList');
          let approverListStr = '';
          if (item.addAuditNodeMemberAOList.length) {
            item.addAuditNodeMemberAOList.forEach(items => {
              approverListStr += items.nodeMemberName + ',';
            });
            approverListStr = approverListStr.substring(0, approverListStr.length - 1);
            this.$set(item, 'approverListStr', approverListStr);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-form-item--small .el-form-item__error {
  width: 270px;
}
</style>
